export type GtagEventParams = {
  // Allow additional custom parameters
  [key: string]: any;
  affiliation?: string;
  client_id?: string;
  coupon?: string;
  // Ecommerce parameters
  currency?: string;
  debug?: any;
  debug_mode?: any;
  gclid?: string;
  // List parameters
  item_list_id?: string;
  item_list_name?: string;
  items?: GtagItem[];
  // Lead parameters
  lead_source?: string;
  // Common parameters
  page_location: string;

  page_title: string;

  // Payment parameters
  payment_type?: string;

  // Search parameters
  search_term?: string;
  shipping?: number;

  tax?: number;

  transaction_id?: string;

  user_id?: string;
  value?: number;
};

export type GtagEvent = {
  event_name: string;
  event_params: GtagEventParams;
};

export type GtagItem = {
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_id: string;
  item_list_id?: string;
  item_list_name?: string;
  item_name: string;
  item_variant?: string;
  location_id?: string;
  price?: number;
  quantity?: number;
};

export enum GtagEventType {
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  CUSTOM = 'custom',
  GENERATE_LEAD = 'generate_lead',
  PAGE_VIEW = 'page_view',
  PURCHASE = 'purchase',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_CART = 'view_cart',
  VIEW_ITEM = 'view_item',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_SEARCH_RESULTS = 'view_search_results',
}
